import FingerprintJS from '@fingerprintjs/fingerprintjs-pro';
import { captureException } from './metrics';
export async function getFingerprint(): Promise<string | undefined> {
  try {
    const apiKey = import.meta.env.VITE_FINGERPRINT_API_KEY;
    if (!apiKey) {
      return undefined;
    }

    const cachedFp = localStorage.getItem('fp');
    if (cachedFp) {
      return cachedFp as string;
    }

    const client = await FingerprintJS.load({
      apiKey: apiKey,
      endpoint: ['https://fp.p2g.com', FingerprintJS.defaultEndpoint],
      scriptUrlPattern: [
        'https://fp.p2g.com/web/v<version>/<apiKey>/loader_v<loaderVersion>.js',
        FingerprintJS.defaultScriptUrlPattern
      ],
      region: 'eu'
    });

    const fp = await client.get();
    const visitorId = fp.visitorId;
    localStorage.setItem('fp', visitorId);
    return visitorId;
  } catch (error) {
    captureException(error, 'Failed to get fingerprint', {
      section: 'fingerprint'
    });
    return undefined;
  }
}
